import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertImageBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Image",
      onItemClick: () => {
        editor.transact(() => {
          const block = insertOrUpdateBlock(editor, {
            type: "imageBlock",
            props: {
              image: "",
              alt: "",
              url: "",
              caption: "",
              pixelWidth: 0,
            },
          });
          editor.setTextCursorPosition(block);
        });
      },
      aliases: ["image", "picture", "photo", "img"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="Image" />,
      subtext: "Add an image with optional caption and link",
    },
  ];
}
